<template>
  <section class="col-start-1 col-end-13 row-start-6 row-end-7 bg-indigo-300 rounded-tl-xl xl:rounded-tl-full">
    <div class="grid grid-cols-columns">
      <div class="col-start-2 col-end-12">
        <div id="contact-container" class="container mx-auto xxl:px-6 py-16">
          <div class="lg:grid lg:grid-cols-2 lg:gap-8 items-center">
            <contact-header />
            <contact-form @messageSent="messageSent"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ContactHeader from "@/components/contact/ContactHeader";
import ContactForm from "@/components/contact/ContactForm";

export default {
  name: "Contact",
  components: {
    ContactHeader,
    ContactForm,
  },
  methods: {
    messageSent(){
      this.$emit('messageSent')
    }
  }
};
</script>

<style scoped>
</style>
